import React from 'react';

import CommonNode from '../../../../components/node/common-node';
import { NodeProvider } from '../../../../context/node-context';
import { getNodeName } from '../../../../utils/getNodeName';
import DeleteFileFromS3TaskForm from './forms/delete-file-from-s3-task-form';
import { deleteFileFromS3TaskValidationSchema } from './schema.js';

export default function FileOperationDeleteFileFromS3Node({ data, id, type }) {
  const nodeName = getNodeName(data?.name, 'File Operation Delete File From S3 Task');

  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: nodeName,
        altText: 'File Operation Delete File From S3 Task',
        defaultLabel: 'File Operation Delete File From S3 Task',
      }}
    >
      <CommonNode
        FormComponent={DeleteFileFromS3TaskForm}
        schemaResolver={deleteFileFromS3TaskValidationSchema}
      />
    </NodeProvider>
  );
}
